/* eslint-disable no-param-reassign */
/**
 * @see https://stackoverflow.com/a/35323290
 */
export function resetFileInput(input) {
  input.value = '';

  if (!/safari/i.test(navigator.userAgent)) {
    input.type = '';
    input.type = 'file';
  }
}
